/**
 * Viewer/H5 路由守卫：无 join session 时重定向到 Join Gate
 */

import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { hasJoinSession } from '../composables/useCrV3JoinSession'

/** 8 位 meetingCode 且无 sessionStorage 会话 → /cr-v3/join/:code */
export function crV3JoinSessionBeforeEnter(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): void {
  const code = String(to.params.code || '')
  if (/^\d{8}$/.test(code) && !hasJoinSession(code)) {
    next({ name: 'CrV3Join', params: { code } })
  } else {
    next()
  }
}
